
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topics/[topic]",
      function () {
        return require("private-next-pages/topics/[topic]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topics/[topic]"])
      });
    }
  